import { render, staticRenderFns } from "./editFunktion.vue?vue&type=template&id=64330356&scoped=true&"
import script from "./editFunktion.vue?vue&type=script&lang=js&"
export * from "./editFunktion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64330356",
  null
  
)

export default component.exports